export default {
  'Resize for': '調整大小',
  'Add 10 videos at most': '最多添加10個視頻。',
}